<template>
    <div class="col-md-12 px-0 py-0">
        <div class="form-group row">
            <div class="col-md-7">
                <div class="form-row align mt-3">
                    <div class="form-group col-md-3">
                        <select class="form-control" v-model="criterio">
                            <option value="name">Nombre</option>
                            <option value="contest">Concurso</option>
                            <option value="userName">Responsable</option>
                            <option value="email">Correo</option>
                            <option value="category">Categoria</option>
                            <option value="country">Pais</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <input
                            type="text"
                            v-model="search"
                            @keyup.enter="getListModel()"
                            class="form-control"
                            placeholder="Texto a buscar"
                        />
                    </div>
                    <button
                        type="button"
                        @click="getListModel()"
                        class="btn btn-primary mb-3"
                    >
                        <em class="fa fa-search"></em> Buscar
                    </button>
                </div>
            </div>
            <div class="col-md-5">
                <div class="form-row align mt-3">
                    <div class="form-group col-md-8">
                        <select class="form-control" v-model="contestId">
                            <option value="0">Seleccionar Concurso</option>
                            <option
                                v-for="item in contestList"
                                :value="item.id"
                                :key="item.id"
                            >
                                {{ item.name }} / v-{{ item.version }}
                            </option>
                        </select>
                    </div>
                    <button
                        type="button"
                        @click="descargarProyectos()"
                        class="btn btn-primary mb-3"
                    >
                        <em class="fa fa-excel"></em> Exportar
                    </button>
                </div>
            </div>
        </div>
        <table
            class="table table-bordered table-striped table-sm mt-3"
            style="table-layout: fixed"
        >
            <thead>
                <tr>
                    <th style="width: 120px">Opciones</th>
                    <th>ID</th>
                    <th>Concurso</th>
                    <th>Nombre</th>
                    <th>Responsable</th>
                    <th>Tipo</th>
                    <th>Estado Formulario</th>
                    <th>Categoria</th>
                    <th>Pais</th>
                    <th>Fecha Inscripción</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            v-tooltip.bottom-start="'Ver Detalle'"
                            type="button"
                            @click="changeView(5, model.id, model.name)"
                            class="btn btn-info btn-sm"
                        >
                            <em class="fa fa-eye"></em>
                        </button>
                        <button
                            v-tooltip.bottom-start="'Editar'"
                            type="button"
                            @click="changeView(8, model.id, model.name)"
                            class="btn btn-warning btn-sm"
                        >
                            <em class="fa fa-edit"></em>
                        </button>
                        <button
                            v-tooltip.bottom-start="'Migrar a Comunidad'"
                            v-if="handleIfIsMigrableProject(model)"
                            v-bind:id="model.id"
                            type="button"
                            @click="migrateProject(model.id)"
                            class="btn btn-success btn-sm"
                        >
                            <em class="fa fa-exchange"></em>
                        </button>
                    </td>
                    <td v-text="model.id"></td>
                    <td v-text="model.contest.name"></td>
                    <td>
                        <span
                            class="badge"
                            :class="handleIfIsActiveProject(model).color"
                            >{{ handleIfIsActiveProject(model).title }}</span
                        >
                        <span
                            class="badge"
                            :class="handleIfIsFinalistOrWinner(model).color"
                            >{{ handleIfIsFinalistOrWinner(model).title }}</span
                        >
                        {{
                            model.name
                        }}
                    </td>
                    <td v-text="model.user.name"></td>
                    <td v-text="model.type_startup_original"></td>
                    <td
                        v-text="
                            model.is_completed && model.is_full_information
                                ? 'Completo'
                                : 'Incompleto'
                        "
                    ></td>
                    <td v-text="model.category ? model.category.name : ''"></td>
                    <td
                        v-text="
                            model.countries[0] ? model.countries[0].name : ''
                        "
                    ></td>
                    <td v-text="model.created_at"></td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import helpers from "../../mixins/index";

export default {
    name: "ProjectList",
    mixins: [helpers],
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            criterio: "name",
            search: "",
            contestId: "0",
            contestList: [],
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        migrateProject(projectId) {
            const me = this;
            this.$swal({
                title: `Esta seguro de migrar a comunidad el proyecto con ID ${projectId}`,
                text: "No podrás revertir esto!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1c8eb7",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Migrar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    me.singleMigration(projectId);
                }
            });
        },

        singleMigration(projectId) {
            const me = this;
            me.loading();
            axios
                .post(`/api/projects/single-migration?project_id=${projectId}`)
                .then(function (response) {
                    const { data } = response.data;
                    if (data.success) {
                        me.showAlert(
                            "success",
                            `El registro ${data?.data?.post?.group} ha sido creado.`,
                            `El proyecto se ha migrado a comunidad.`
                        );
                    }
                })
                .catch(function (error) {
                    let content = "";

                    if (error.response.status === 422) {
                        if (
                            typeof error.response?.data?.messages === "string"
                        ) {
                            content = error.response?.data?.messages;
                        } else {
                            const errors = Object.values(
                                error.response?.data?.messages
                            );
                            content = errors
                                .map((item) => `<li>${item}</li>`)
                                .join("");
                        }
                        me.showSwalError(`<ul>${content}</ul>`);
                    } else {
                        me.showSwalError(
                            "No fue posible procesar su solicitud, intente mas tarde."
                        );
                    }
                })
                .finally(() => {
                    me.closeLoading();
                });
        },
        descargarProyectos() {
            if (this.contestId > 0) {
                window.open("/export/" + this.contestId);
            }
        },
        getListContest() {
            let _this = this;
            axios
                .get("/api/contests?paginate=false")
                .then(function (response) {
                    _this.contestList = response.data;
                })
                .catch(function (error) {});
        },
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page);
        },
        getListModel(page = 1) {
            let me = this;
            let criterio = me.criterio;
            let search = me.search;
            axios
                .get(
                    "/api/projects?page=" +
                        page +
                        "&criterio=" +
                        criterio +
                        "&search=" +
                        search
                )
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        changeView(page, id, name) {
            this.$emit("change", { page: page, id: id, name: name });
        },
        handleIfIsMigrableProject(project) {
            return (
                project.send_community == 0 &&
                project.is_full_information &&
                project.is_completed &&
                project.is_general_completed &&
                project.is_model_completed &&
                project.is_team_completed
            );
        },
        handleIfIsFinalistOrWinner(project) {
            let data = {
                color: "",
                title: "",
            };

            if (project.is_finalist === 1 && project.is_winner === 0) {
                data = {
                    color: "badge-primary text-white",
                    title: "Finalista",
                };
            }

            if (project.is_finalist === 0 && project.is_winner === 1) {
                data = {
                    color: "badge-warning",
                    title: "Ganador",
                };
            }

            return data;
        },
        handleIfIsActiveProject(project) {
            let data = {
                color: "badge-success",
                title: "Activo",
            };

            if (project.is_active !== 1) {
                data = {
                    color: "badge-danger",
                    title: "Inactivo",
                };
            }

            return data;
        },
    },
    mounted() {
        this.getListModel();
        this.getListContest();
    },
};
</script>

<style scoped>
.form-control {
    border-radius: 0.2rem !important;
    height: 37px;
}

select.form-control:not([size]):not([multiple]) {
    height: 37px;
}

.btn {
    height: 37px !important;
}

.align {
    display: flex;
    align-items: center;
}
</style>
